<div class="view">
  <div class="head"></div>
  <div class="body">
    <app-auth-sig-up></app-auth-sig-up>
  </div>
</div>
